<template>
  <div class="h100vh-116">
    <div class="h100vh-180">
      <ejs-grid ref='grid' :dataSource="data" :allowResizing='true' height="calc(100% - 0px)">
        <e-columns>
          <e-column type='checkbox' headerText='id' width='40' textAlign='Center'></e-column>
          <e-column field='neid' :headerText="$t('DataManagent.neid')" width='150' textAlign='Center'></e-column>
          <e-column field='clientIp' :headerText="$t('DataManagent.clientIp')" width='150' textAlign='Center' clipMode='EllipsisWithTooltip'></e-column>
          <e-column field='destIp' :headerText="$t('DataManagent.distIp')" width='150' textAlign='Center'></e-column>
          <e-column field='systemUser' :headerText="$t('DataManagent.systemUser')" width='150' textAlign='Center'></e-column>
          <e-column field='opTime' :headerText="$t('DataManagent.opTime')" width='150' textAlign='Center'></e-column>
          <e-column field='neVersion' :headerText="$t('DataManagent.neVersion')" width='150' textAlign='Center'></e-column>
          <e-column field='opType' :headerText="$t('DataManagent.opType')" width='150' textAlign='Center' clipMode='EllipsisWithTooltip' :formatter='optypeFormat'></e-column>
          <e-column field='opResult' :headerText="$t('DataManagent.opResult')" width='150' textAlign='Center' :formatter='opresultFormat'></e-column>
        </e-columns>
      </ejs-grid>
    </div>
    <div class="h-system-hide-upload">
      <ejs-uploader
        autoUpload="false"
        allowedExtensions=".tar.gz"
        :multiple="false"
        id="file"
        :selected="onFileSelect"
        ref="importData"
      ></ejs-uploader>
    </div>
  </div>
</template>

<script>
import socketInstance from '../../../plugins/stompSock';
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'DataTable',
  data() {
    return {
      data: [],
      websocketSetting: [
        { topic: '/user/#/datamanage', clientId: 'subscriber', callback: this.setWebSocketCallback }
      ],
      param: {
        neid: ''
      },
      successCode: 'SUCCESS',
      ok: 'ok',
      fail: 'fail',
      flag: 0, // 0表示没有任务，1正在上传，2正在下载
      upLoadResult: undefined,
      neinfoMap: new Map(),
      exportFileName: {
        4: 'hssuser.tar.gz', // hss netype 3
        12: 'mcsUser.tar.gz', //  mcs
        14: 'mcsGroup.tar.gz', // gms
      },
      opTypeArray: [this.$t('DataManagent.import'), this.$t('DataManagent.export')],
      opResultMap: {
        'ok': this.$t('DataManagent.success'),
        'fail': this.$t('DataManagent.fail'),
      },
      userId: undefined
    };
  },
  methods: {
    // 查询数据管理日志
    initLogData(args) {
      console.log('查询日志', args);
      const $this = this;
      const neid = args !== undefined ? args.data.id : $this.param.neid;
      $this.param.neName = args !== undefined ? args.data.text : neid;
      if (this.neinfoMap.get(neid) === undefined || this.neinfoMap.get(neid).length === 0) {
        this.neinfoMap.set(neid, this.exportFileName[args.data.neType]);
      }
      console.log(this.neinfoMap);
      $this.param.neid = neid;
      const param = {
        url: '/lte/ems/subscriber/hssoper/log/queryAll',
        config: {},
        formData: {
          neid
        },
        callFun: $this.logDataCallFun,
        loadRemoveFlag: true
      };
      this.commonRequest(param);
    },
    logDataCallFun(response) {
      const $this = this;
      const res = response.data.resultVal;
      $this.data = res;
    },
    uploadCallFun(response) {
      if (response.data.resultVal) {
        // 上传成功需要给设备侧下发业务
        console.log('upload response=', response);
        this.importData(response.data.resultVal);
      } else {
        this.$loading.hideLoadding();
        EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
      }
    },
    exportFun() {
      this.isChooseNeWithCall(this.exportFunCall, undefined);
    },
    exportFunCall() {
      this.flag = 2;
      // 给设备侧发信息
      const param = {
        url: '/lte/ems/subscriber/hssoper/exports',
        formData: {
          neid: this.param.neid,
        },
        callFun: undefined,
        loadRemoveFlag: false
      };
      this.commonRequest(param);
    },
    downloadFun(res) {
      console.log(res);
      // const remotePath = '/subscriber/10/imports/20200325093842/'; // /home/ems/ems_file/ftp/file/subscriber/10/imports/20200324133301/
      const param = {
        url: '/lte/ems/subscriber/hssoper/download',
        config: {
          responseType: 'blob'
        },
        callFlag: true,
        formData: {
          neid: this.param.neid,
          remotePath: res,
          fileName: this.neinfoMap.get(this.param.neid),
        },
        callFun: this.downloadCallFun,
        loadRemoveFlag: false
      };
      this.commonRequest(param);
    },
    downloadCallFun(res) {
      // this.$loading.hideLoadding();
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement('a');
      link.style.display = 'none';
      link.href = url;
      console.log(this.neinfoMap.get(this.param.neid));
      const filename = this.neinfoMap.get(this.param.neid);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      this.initLogData();
      this.$loading.hideLoadding();
    },
    importData(res) {
      this.flag = 1;
      this.upLoadResult = res;
      const param = {
        url: '/lte/ems/subscriber/hssoper/imports',
        config: {},
        formData: {
          neid: this.param.neid,
          remotePath: this.upLoadResult.ftpFilePath
        },
        callFun: undefined,
        loadRemoveFlag: true
      };
      this.commonRequest(param);
    },
    // websocket初始化
    webSocketInit() {
      this.userId = JSON.parse(sessionStorage.getItem('principal')).userId;
      console.log('userId=', this.userId);
      socketInstance.init(this.websocketSetting);
    },
    // 接收websocket推送的消息--进行页面处理
    setWebSocketCallback(msg) {
      console.log('开户的websocket', msg);
      if (msg) {
        const $this = this;
        const mess = JSON.parse(msg.body);
        if ($this.flag !== 0 && mess.userId === $this.userId) {
          if (mess.errorCodeOam.indexOf('2148642824') > -1) {
            $this.$loading.hideLoadding();
            EventBus.$emit('toast', { type: 'warning', content: $this.$t('DataManagent.requestTimeOut') });
            return;
          }
          mess.errorCodeOam = mess.errorCodeOam && mess.errorCodeOam.split('.').length >= 3 ? mess.errorCodeOam.split('.')[2] : mess.errorCodeOam;
          mess.errorCodeDevice = mess.errorCodeDevice && mess.errorCodeDevice.split('.').length >= 3 ? mess.errorCodeDevice.split('.')[2] : mess.errorCodeDevice;
          if (mess.errorCodeOam && mess.errorCodeOam !== '0') {
            $this.$loading.hideLoadding();
            //  此处是相对设备而言的导入导出操作，与上面相反，后续是否需要统一展示，可能会对用户造成误解---2.0遗留
            $this.addNormLog(this.param.neid, mess.type === '6' || mess.type === '8' || mess.type === '10' ? 1 : 0, 'fail');
            const paramObj = JSON.parse(mess.errorParams);
            EventBus.$emit('toast', { type: 'warning', content: mess.errorCodeOamStr.format(paramObj[0], paramObj[1], paramObj[2]) });
          } else if (mess.errorCodeDevice && mess.errorCodeDevice !== '0') {
            $this.$loading.hideLoadding();
            //  此处是相对设备而言的导入导出操作，与上面相反，后续是否需要统一展示，可能会对用户造成误解---2.0遗留
            $this.addNormLog(this.param.neid, mess.type === '5' || mess.type === '7' || mess.type === '9' ? 0 : 1, 'fail');
            if (mess.errorCodeDevice.indexOf('2418016536') > -1) {
              EventBus.$emit('toast', { type: 'warning', content: $this.$t('DataManagent.createDataFileFail') });
            } else {
              // heroLayer.error(mess.deviceString);
              EventBus.$emit('toast', { type: 'warning', content: mess.errorCodeDeviceStr });
            }
          } else {
            // hss or gms exports
            if ((mess.type === '6' || mess.type === '8' || mess.type === '10') && mess.result === 'OK') {
              this.downloadFun(mess.remotePath);
            }
            // hss or gms imports
            if ((mess.type === '5' || mess.type === '7' || mess.type === '9') && mess.result === 'OK') {
              $this.$loading.hideLoadding();
              $this.addLog();
            }
          }
          $this.flag = 0;
        }
      }
    },
    // onFileSelect() {
    //   this.isChooseNeWithCall(this.onFileSelectCall, undefined);
    // },
    onFileSelect(args) {
      if (args.filesData[0].type === 'gz' && args.filesData[0].name.indexOf('.tar.') > -1) {
        if (this.isChooseNe() === false) {
          return;
        }
        const uploadFile = document.getElementById('file').files[0];
        this.$loading.showLoadding(this.$t('MML.loadingTip'));
        const formData = new FormData();
        formData.append('neid', this.param.neid);
        formData.append('file', uploadFile);
        const config = {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        };
        this.$refs.importData.clearAll();
        // this.$loading.hideLoadding();
        console.log('=============', config, formData);
        const param = {
          url: '/lte/ems/subscriber/hssoper/upload',
          config,
          formData,
          callFun: this.uploadCallFun,
          loadRemoveFlag: false
        };
        this.commonRequest(param);
      } else {
        this.$refs.importData.clearAll();
        EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.impFileTypeErrTip') });
      }
    },
    isChooseNe() {
      if (this.param.neid === undefined || this.param.neid === '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('DataManagent.chooseNeidTip') });
        return false;
      }
      return true;
    },
    /**
     * 导入 导出
     */
    openImportPage() {
      document.getElementsByClassName('e-file-select-wrap')[0].querySelector('button').click();
      return false;
    },
    addLog() {
      this.upLoadResult.log.systemId = this.param.neid;
      const param = {
        url: '/lte/ems/subscriber/hssoper/log/add',
        config: {},
        formData: {
          result: this.upLoadResult,
          neid: this.param.neid
        },
        callFun: this.refreshData,
        loadRemoveFlag: true
      };
      this.commonRequest(param);
    },
    // 设备侧返回失败的日志记录
    addNormLog(neid, opType, opResult) {
      const param = {
        url: '/lte/ems/subscriber/hssoper/log/normAdd',
        config: {},
        formData: {
          neid,
          opType,
          opResult
        },
        callFun: this.refreshData,
        loadRemoveFlag: true
      };
      this.commonRequest(param);
    },
    deleteLog() {
      console.log('删除日志记录=', this.$refs.grid.getSelectedRecords());
      const select = this.$refs.grid.getSelectedRecords();
      if (select && select.length > 0) {
        this.$layer.confirm({
          msg: this.$t('LteUser.delConfirm'),
          btn1: {
            msg: this.$t('MCS.cancle')
          },
          btn2: {
            msg: this.$t('System.confirm'),
            func: () => {
              const param = {
                url: '/lte/ems/subscriber/hssoper/log/delete',
                config: {},
                formData: select,
                callFun: this.refreshData,
                loadRemoveFlag: false
              };
              this.commonRequest(param);
            }
          }
        });
      } else {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('DataManagent.chooseDataTip') });
      }
    },
    commonRequest(param) {
      this.$loading.showLoadding(this.$t('MML.loadingTip'));
      this.$axios.post(param.url, param.formData, param.config).then((response) => {
        if (param.loadRemoveFlag) {
          this.$loading.hideLoadding();
        }
        console.log(response);
        if (response.status === 200) {
          // 成功后的操作
          if (response.data.errorCode === this.successCode || param.callFlag) {
            const fun = param.callFun;
            fun !== undefined && param.callFun(response);
          } else {
            EventBus.$emit('toast', { type: 'warning', content: response.data.errorString });
          }
        } else {
          EventBus.$emit('toast', { type: 'warning', content: this.$t('SubscriberIms.requestResTip') });
        }
      });
    },
    refreshData() {
      this.isChooseNeWithCall(this.refreshDataCall, undefined);
    },
    refreshDataCall() {
      // if (this.isChooseNe() === false) {
      //   return;
      // }
      this.initLogData();
    },
    optypeFormat(grids, data) {
      return this.opTypeArray[data.opType];
    },
    opresultFormat(grids, data) {
      console.log('333333', data.opResult);
      return this.opResultMap[data.opResult];
    },
    isChooseNeWithCall(callFun, param) {
      if (this.param.neid === undefined || this.param.neid === '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('DataManagent.chooseNeidTip') });
        return false;
      }
      this.checkNeStatus(callFun, param);
    },
    checkNeStatus(callFun, param) {
      this.axios.get(`/lte/ems/config/mml/queryNodeLinkStatus/${this.param.neid}`).then(res => {
        const nodeStatus = res.data ? res.data.resultVal : 0;
        if (nodeStatus === 0) {
          EventBus.$emit('toast', { type: 'warning', content: this.$t('Common.neOffLine', [this.param.neName]) });
        } else {
          if (param === undefined) {
            callFun();
          } else {
            callFun(param);
          }
        }
      });
    }
  },
  mounted() {
    this.webSocketInit();
  },
  beforeDestroy() {
    socketInstance.stopReceiveTopicMsg(this.websocketSetting[0].clientId, this.websocketSetting[0].topic);
  },
};
</script>

<style scoped>

</style>
